/* eslint-disable react/prefer-stateless-function */
import React from 'react';
// Packages
import { Row, Col, Container } from 'react-bootstrap';
import Layout from '../components/layout';
import Seo from '../components/seo';

function NotFound() {
  return (
    <Layout>
      <Seo title="404 - Marshmoor Bricks" description="Error 404. This page does not exist." />
      <div>
        <Container className="mt-5 mb-5 pt-5">
          <Row className="shadow-12">
            <Col className="p-4">
              <h2>
                404: Like the perfect partner, this page doesn&apos;t exist.
              </h2>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
}

export default NotFound;
